import React, { useEffect, useState } from 'react';
import { CheckCircle2, Clock } from 'lucide-react';
import { recuentosAPI } from '@/lib/recuentos';

export const EstadoSemanalCard = ({ onOpen, filterCodigos = null, refreshKey = 0 }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    recuentosAPI.estadoSemanal().then((r) => setData(r.data)).catch(() => setData(null));
  }, [refreshKey]);

  if (!data) return null;
  const lugares = filterCodigos ? data.lugares.filter((l) => filterCodigos.includes(l.codigo)) : data.lugares;
  const listos = lugares.filter((l) => l.enviado).length;

  return (
    <div className="bg-white rounded-xl border border-orange-100 p-4" data-testid="estado-semanal-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-slate-800">Recuento del lunes {data.fecha_lunes}</h3>
        <span className="text-sm text-slate-500" data-testid="estado-semanal-resumen">{listos} de {lugares.length} enviados</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {lugares.map((l) => (
          <button
            key={l.codigo}
            type="button"
            disabled={!l.recuento_id || !onOpen}
            onClick={() => onOpen && l.recuento_id && onOpen(l.recuento_id)}
            className={`flex items-center gap-2 rounded-lg px-3 py-2 text-left text-sm border transition-colors ${
              l.enviado ? 'bg-green-50 border-green-200 text-green-800' : 'bg-amber-50 border-amber-200 text-amber-800'
            } ${l.recuento_id && onOpen ? 'hover:brightness-95 cursor-pointer' : 'cursor-default'}`}
            data-testid={`estado-semanal-${l.codigo}`}
          >
            {l.enviado ? <CheckCircle2 className="w-4 h-4 shrink-0" /> : <Clock className="w-4 h-4 shrink-0" />}
            <span className="font-medium">{l.nombre}</span>
            <span className="ml-auto text-xs">{l.enviado ? 'Listo' : l.estado === 'borrador' ? 'En curso' : 'Falta'}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
